import { Card, CardContent } from '@/components/ui/card';
import { LoginArea } from '@/components/auth/LoginArea';
import { BackButton } from '@/components/stashstr/BackButton';
import { useCurrentUser } from '@/hooks/useCurrentUser';
import { PostForm } from '@/components/stashstr/PostForm';

export default function PostPage() {
  const { user } = useCurrentUser();

  return (
    <div>
      <BackButton />
      <h1 className="text-[18px] font-bold text-gray-900 dark:text-gray-100 mb-3">post</h1>
      {user ? (
        <PostForm />
      ) : (
        <Card className="border-dashed">
          <CardContent className="py-12 text-center flex flex-col items-center gap-3">
            <p className="text-muted-foreground text-[14px]">
              Log in to post links, discussions, bounties and polls.
            </p>
            <LoginArea className="max-w-60" />
          </CardContent>
        </Card>
      )}
    </div>
  );
}
